import { useEffect } from "react";
import "@/App.css";
import { HashRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { LanguageProvider } from "@/lib/lang";
import TopBar from "@/components/TopBar";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import PracticeAreas from "@/components/PracticeAreas";
import About from "@/components/About";
import Team from "@/components/Team";
import Method from "@/components/Method";
import Sede from "@/components/Sede";
import News from "@/components/News";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Privacy from "@/components/Privacy";
import Admin from "@/components/Admin";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  return null;
}

function Home() {
  return (
    <main>
      <Hero />
      <Marquee />
      <PracticeAreas />
      <About />
      <Team />
      <Method />
      <Sede />
      <News />
      <Contact />
    </main>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1, touchMultiplier: 1.4 });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <LanguageProvider>
        <HashRouter>
          <ScrollToTop />
          <div className="bg-alabaster text-ink antialiased">
            <TopBar />
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Home />} />
            </Routes>
            <Footer />
            <Toaster richColors position="bottom-right" theme="dark" />
          </div>
        </HashRouter>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
